import React from 'react';
import clsx from 'clsx';
import {
  Card,
  CardContent,
  CardHeader,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { ReactComponent as TrophyIcon } from "assets/icons/trophy.svg";
import flag from 'assets/images/flag.png'

function createData(name, country, amount) {
  return { name, country, amount };
}

export default function DonorSection(props) {
  
  const classes = useStyles();

  return (
    <Card className={clsx(classes.card, 'Top Donors')}>
      <CardHeader
        className={classes.cardHeader}
        classes={{
          title: 'Top Donors',
        }}
        title='Top Donors'
        avatar={
          <TrophyIcon />
        }
      />
      <CardContent className="table-card">
        <TableContainer>
          <Table className={classes.table} aria-label="simple table">
            <TableHead className={classes.tableHeader}>
              <TableRow>
                <TableCell className="table-heading">Name</TableCell>
                <TableCell className="table-heading" align="center">Country</TableCell>
                <TableCell className="table-heading" align="center">Amount</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {props.donorsData.length > 0 ? props.donorsData.map((row, i) => (
                <TableRow key={i}>
                  <TableCell className="table-rows">
                    <div className={classes.nameContainer}>
                      <img src={row.user.image} className={classes.profile}/>
                      <span className={classes.name}>{row.user.first_name + " " + row.user.last_name}</span>
                    </div>
                  </TableCell>
                  <TableCell className="table-rows" align="center"><img src={flag} /></TableCell>
                  <TableCell className="table-rows" align="center">${row.amount}</TableCell>
                </TableRow>
              ))
              :
              <TableRow>
                <TableCell>
                  No data found
                </TableCell>
              </TableRow>
            }
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
}


const useStyles = makeStyles((theme) => ({
  card: {
    boxShadow: "0px 2px 10px #E5E9F2",
    borderRadius: 5,
    border: '1px solid #E6EAEE'
  },
  profile: {
    width: 32,
    height: 32,
    borderRadius: '50%'
  },
  cardHeader: {
    padding: theme.spacing(2, 3, 0, 3),
  },
  title: {
    fontSize: 16,
    fontWeight: 500,
  },
  cardContent: {
    paddingTop: 0,
  },
  settingIcon: {
    width: 20,
    height: 20
  },
  table: {
  },
  tableHeader: {
    background: '#F5F8FA',
    border: '1px solid #E6EAEE',
    boxSizing: 'border-box',
    borderRadius: 0,
  },
  nameContainer: {
    display: 'inline-flex'
  },
  name: {
    lineHeight: 2,
    paddingLeft: 10
  }
}));

